import renderPage from './common/renderPage';
import '@ali/lib-mtop';
import { registerComponents } from './components';
import imageTransfer from './common/lazyload';
import  aplusConfig from './common/aplusConfig';
import './index.less';

// 打点绑定
aplusConfig();
// 注册组件
registerComponents();
window.renderComponents = renderPage;

